import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  input,
  OnDestroy,
  output,
  viewChild,
} from '@angular/core';
import Quill from 'quill';

const quillConfig = {
  theme: 'snow',
  modules: {
    toolbar: '#toolbar',
    /*
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],
      ['link', 'image'],
    ],
    */
  },
};

export type RichTextEditorFeature =
  | 'font'
  | 'font-format'
  | 'color'
  | 'list'
  | 'image'
  | 'link';

@Component({
  selector: 'soft-rich-text-editor-core',
  templateUrl: './rich-text-editor-core.component.html',
  styleUrls: ['./rich-text-editor-core.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class RichTextEditorCoreComponent implements AfterViewInit, OnDestroy {
  quill: Quill | undefined;

  content = input<string | null>(null);

  contentChange = output<string | null>();

  features = input.required<RichTextEditorFeature[]>();

  editorElement = viewChild.required<ElementRef<HTMLElement>>('quillEditorContainer');

  constructor() {
    effect(() => {
      const element = this.editorElement();
      if (!element || !this.quill) return;
      const content = this.content();
      if (content !== '' && content !== null) {
        this.quill.root.innerHTML = content;
      } else if (content === null) {
        this.quill.root.innerHTML = '';
      }
    });
  }

  ngAfterViewInit(): void {
    this.quill = new Quill(this.editorElement().nativeElement, quillConfig);
    const content = this.content();

    if (content !== '' && content !== null) {
      this.quill.root.innerHTML = content;
    }

    this.quill.focus();

    if (this.quill !== undefined) {
      this.quill.on('text-change', () => {
        const html = this.quill?.root.innerHTML ?? '';
        if (!this.htmlIsEmpty(html)) {
          this.contentChange.emit(html);
        } else {
          this.contentChange.emit(null);
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.quill !== undefined) {
      this.quill?.off('text-change');
      this.quill = undefined;
    }
  }

  htmlIsEmpty(content: string): boolean {
    // Remove all HTML tags and trim whitespace
    const text = content.replace(/<[^>]*>/g, '').trim();
    return text === '';
  }

  includesFeature(feature: RichTextEditorFeature) {
    return this.features().includes(feature);
  }
}
